// extracted by mini-css-extract-plugin
export default {"layout":"Message_layout__Zolr8","box":"Message_box__vcISp","title":"Message_title__C7n3g"};